export default __webpack_public_path__ + "static/2-7380388564a1b1568a72b24434b45726.png";